<template>
  <table
    class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400"
  >
    <thead class="text-xs text-gray-700 uppercase bg-gray-50">
      <tr>
        <slot name="head" />
      </tr>
    </thead>

    <tbody>
      <tr
        v-for="(row, index) in data"
        :key="index"
        class="bg-white border-b hover:bg-gray-50"
      >
        <!-- foto, nome e função -->
        <th
          scope="row"
          class="flex items-center px-6 py-4 text-gray-900 whitespace-nowrap"
        >
          <!-- foto -->
          <img
            class="w-10 h-10 rounded-full"
            :src="
              !row['avatar']
                ? defaultImg
                : row['avatar']
            "
            :alt="'Foto de ' + row['name']"
          />

          <!-- nome e função -->
          <div class="ps-3">
            <div class="text-base font-semibold">
              {{
                row["name"].length > 20
                ? row["name"].slice(0, 20).concat('...')
                : row["name"]
              }}
            </div>
          </div>
        </th>

        <!-- email e cpf -->
        <td scope="row" class="px-6 py-4 whitespace-nowrap">
          <div>
            <div
              title="email"
              class="text-base text-gray-900"
            >
              {{
                row["email"]
                  ? row["email"]
                  : 'não informado'
              }}
            </div>

            <div class="font-normal text-gray-500 lowercase">
              {{
                row["cpf"]?.length > 20
                  ? row["cpf"].slice(0, 20).concat("...")
                  : row["cpf"] ?? 'não informado'
              }}
            </div>

          </div>
        </td>

        <!-- participações em eventos -->
        <td class="px-1 py-4 text-center">
          <div class="text-center" :class="[row['coupon']?.length == 0 ? 'italic text-text-gray-400' : '']">
            {{
              row["coupon"]?.length > 0
              ? row["coupon"]?.length
              : 'sem eventos agendados'
            }}
          </div>
        </td>

        <!-- ações -->
        <td class="px-6 py-4">
          <div class="flex justify-center font-medium">

            <!-- editar -->
            <router-link
              title="Alterar dados do colaborador"
              class="text-yellow-600 mr-1 hover:underline cursor-pointer"
              :to="'/fighters/edit/' + row['id']"
            >
              <component :is="PhNotePencil" class="h-6 w-6" />
            </router-link>

            <a
              :title="'Desativar ' + row['name'] + ' da lista'"
              @click="deleteEmployee(row['id'])"
              class="text-red-600 ml-1 hover:underline cursor-pointer"
            >
              <component :is="PhTrash" class="h-6 w-6" />
            </a>

          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script setup>
import ReportModal from '@/components/Modals/Reports.vue'
import collabService, { PATH } from '../services/collab.service'
import Create from '@/components/Buttons/Create.vue'
import Preview from './Report/Preview.vue'
import moment from 'moment'
import { PhFileDoc, PhNotePencil, PhPencilCircle, PhPencilSimple, PhPenNib, PhTrash, PhWhatsappLogo } from '@phosphor-icons/vue'
import { PdfCreate } from '@/utils/reports/generate-blob'
import { showToast as toast } from '@/helpers/UseToasts'
import { defineProps, ref } from 'vue'
import { storeApp } from '@/store'
import { dataFighters } from '../store'

const imageServe = process.env.VUE_APP_IMAGE_SERVE + 'storage/'
const defaultImg = require('@/assets/logo/icon.png')

const props = defineProps({
  data: [Object, Array]
})

const emit = defineEmits(['delete'])

async function deleteEmployee (id) {
  storeApp.state.loading = true
  const confirm = window.confirm('Deseja realmente remover esse colaborador?')
  if (confirm) {
    collabService.deleteFighter(id)
      .then(res => {

        Promise.all([
          getCustomers()
        ])

        if (res.data.success) {
          toast(
            'Sucesso',
            res.data.message,
            'success'
          )

          // dataFighters.dispatch('setFightersCollect', res.data.fighters)
        }
      }).catch(err => {
        toast(
          'Aviso',
          err.response.data.error,
          'error'
        )
      })
  }
  storeApp.state.loading = false
}

async function getCustomers () {
  await collabService.getCustomers()
    .then(res => {
      dataFighters.dispatch('setFightersCollect', res.data)
    }).catch(err => {
      toast(
        'Erro',
        'Algo deu errado ao buscar coleção alunos',
        'error'
      )
    })
}

// function formatDate (date) {
//   if (date !== null) {
//     return moment(date).format('D/MM/Y')
//   }

//   return 'não informado'
// }

</script>
